import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_LIVE_CHARGING_SESSION = createActionTypes('FETCH_LIVE_CHARGING_SESSION');
